export default __webpack_public_path__ + "static/media/bag3.f128f730.jfif";